import { Logo } from '../App';

export function Welcome({ reason }: { reason: string }) {
  return (
    <div className="flex h-full flex-col items-center justify-center px-6 text-center">
      <Logo size={56} />
      <h1 className="mt-6 text-2xl">SynFolio</h1>
      <p className="mt-2 max-w-sm text-sm text-cream-2">
        Sign in with your work account to continue.
      </p>
      <p className="mt-6 max-w-sm text-xs text-cream-3">{reason}</p>
    </div>
  );
}
